import Sentry from '../instrument';

export interface Observability {
  captureException: (error: unknown, context?: Record<string, unknown>) => void;
  captureMessage: (
    message: string,
    level?: 'info' | 'warning' | 'error'
  ) => void;
}

export const observability: Observability = {
  captureException: (error, context) =>
    Sentry.captureException(error, { extra: context }),
  captureMessage: (message, level) => Sentry.captureMessage(message, level),
};
